<template>
  <!-- Event -->
  <div @click="noticeEvent('showNotice')">
    <block-title @noticeEvent="noticeEvent" :message="message" />
    <div class="classLabel seeMoreLabel" v-if="message.user_type != 5">
      <span v-if="message.class_label">
        Class:
        <b>{{ message.class_label }}</b>
      </span>
      <span v-if="message.years && !message.class_label">
        Years:
        <b>{{ message.years }}</b>
      </span>
    </div>
    <div class="blockText noticeText eventMiddle" style="position: relative">
      <p style="text-align: center; margin-top: 0px">
        <i
          class="far fa-calendar-alt"
          style="font-size: 23px; margin-bottom: 8px"
        ></i>
        &nbsp;&nbsp;
        <span style="letter-spacing: 1px">
          <b>EVENT</b>
        </span>
        <br />
        <b>{{ message.title }}</b>
        <br />
        <b class="eventDate">{{ message.extras.date }}</b>
      </p>
      <div class="insideRect"></div>
    </div>
    <div>
      <p
        v-if="message.type == 'event'"
        class="blockText noticeText"
        style="margin-top: 0px"
        v-html="message.message"
      ></p>
    </div>
    <div>
      <span class="seeMoreLabel" style>See more</span>
    </div>
    <NoticeFooter :message="message" @footerEvent="noticeEvent" />
    <div
      class="institution"
      v-if="
        message.user_type != 3 &&
        message.user_type != 5 &&
        message.user_type != 1
      "
    >
      <img src="@/assets/triangle.png" class alt />
      <div class="logo">
        <img
          v-if="message.school_logo"
          :src="
            message.bucket_url +
            '/council/schools/photo/100/' +
            message.school_logo
          "
          alt
        />
      </div>
    </div>
  </div>
</template>
<script>
import BlockTitle from "@/components/noticeTypes/other/BlockTitle";
import NoticeFooter from "@/components/noticeTypes/other/NoticeFooter";
export default {
  name: "event",
  components: {
    BlockTitle,
    NoticeFooter,
  },
  props: {
    message: Object,
  },
  methods: {
    noticeEvent(type) {
      this.$emit("noticeEvent", {
        action: type,
        id: this.message.id,
        user_id: this.message.user_id,
      });
    },
  },
};
</script>
